export default {
  name: 'global',
  store() {
    const store = {

      init() {
        console.log('init')
      },
    }

    return store
  },
}
